/* eslint-disable complexity */
import React, { Component } from "react";
import PropTypes from "prop-types";
import style from "./styles";
import { numberToHuman } from "util/number";
import { IconRealtorBlockText, Type } from "@rdc-npm/rdc-ui";
import { agentActivityPriceRanges } from "util/srpUtils/priceUtil";
import Certification from "../../../shared/atoms/Certification/Certification";
import { certificationData as certificationDetails } from "static/staticData/certidata";
import ShowMoreText from "react-show-more-text";
import { MoreLink } from "../../../shared/atoms/AllSectionWrapper/ReadMoreLinks/MoreLink";
import { LessLink } from "../../../shared/atoms/AllSectionWrapper/ReadMoreLinks/LessLink";
import { trackOmnitureClicks } from "static/staticData/omniture/omnitureUtils";
import { OMNITURE_LINK_NAME } from "static/staticData/omniture/trackingConstants";
import { chunkify } from "util/number";
import { encrypt } from "util/common";
import { checkSpecializationTextLongLength } from "util/agentdetailsUtil";
import MobileOnly from "components/general/components/MobileOnly";
import DesktopOnly from "components/general/components/DesktopOnly";
import TabletOnly from "components/general/components/TabletOnly";
import { SELECT_TYPE } from "util/constant";
import { getProfileUrl } from "util/createProfileIdPath";
import { getAgentExp } from "util/stringUtil.js";

import dynamic from "next/dynamic";

const ProfilePicSection = dynamic(() => import("./ProfilePicSection/ProfilePicSection"), {
  ssr: true,
});
const ProfileInComplete = dynamic(() => import("../ProfileInComplete/ProfileInComplete"), {
  ssr: false,
});
const MobileCertification = dynamic(
  () => import("../../../shared/atoms/MobileCertification/MobileCertification"),
  {
    ssr: false,
  },
);

const MoreDetailsListComponent = dynamic(
  () => import("./MoreDetailsListComponent/MoreDetailsListComponent"),
  {
    ssr: false,
  },
);
export default class ProfileSection extends Component {
  state = {
    showMoreArea: false,
    showMoretype: null,
    continueReadingStatus: true,
    servedAreaModified: null,
    specializationsModified: null,
    showDotRealtorRedirectLink: false,
    isReviewClicks: false,
    requestBody: {
      advertiser_id: "",
      tracking_token: "realtors:leads:showcase:ask-a-question",
      address: null,
      city: null,
      adv_email: null,
      adv_name: null,
      url: null,
      number: null,
      number_type: null,
      abbreviation: null,
      member_id: null,
      state: null,
      web_url: null,
      photo: null,
      zip: null,
      variant: "far_dp",
      page_name: "ldp",
      lead_type: "call",
      type: null,
      name: null,
      email: null,
      comment: null,
      is_lead_generated: true,
      referral: null,
      referral_asset: null,
      id: null,
      profileId: "",
    },
  };

  continueReadingHandler = () => {
    this.setState({
      continueReadingStatus: !this.state.continueReadingStatus,
    });
  };
  handleDotRealtorRedirectClose = () => {
    this.setState({ showDotRealtorRedirectLink: false });
  };

  sortByName = (data) => {
    data && data.sort((a, b) => a.name.localeCompare(b.name));
    return data;
  };
  updateShowMoreData = (data, type) => {
    const showDiv = true;
    const setInitialState =
      data &&
      data.map((m) => {
        m.showDiv = showDiv;
        return m;
      });
    if (type === "served_areas") {
      this.setState({
        servedAreaModified: setInitialState,
        showMoreArea: true,
        showMoretype: type,
      });
    } else if (type === "specializations") {
      this.setState({
        specializationsModified: setInitialState,
        showMoreArea: true,
        showMoretype: type,
      });
    }
  };
  updateLessData = (data, type) => {
    const showDiv = false;
    const servedAreaInitialState =
      data &&
      data.map((m, i) => {
        if (i > 19) {
          m.showDiv = showDiv;
        }
        return m;
      });

    if (type === "served_areas") {
      this.setState({
        servedAreaModified: servedAreaInitialState,
        showMoreArea: false,
        showMoretype: type,
      });
    } else if (type === "specializations") {
      this.setState({
        specializationsModified: servedAreaInitialState,
        showMoreArea: false,
        showMoretype: type,
      });
    }
  };
  handleShowMoreClick = (data, type) => {
    this.updateShowMoreData(data, type);
  };
  handleLessMoreClick = (data, type) => {
    this.updateLessData(data, type);
  };
  componentDidUpdate(prevProps) {
    if (prevProps.isUserLoggedIn !== this.props.isUserLoggedIn) {
      if (this.props.isUserLoggedIn && this.state.isReviewClicks) {
        const { agent_bio } = this.props?.agentdetail;
        this.props.showReviewModal(agent_bio);
      }
    }
  }
  componentDidMount() {
    const { agentdetail } = this.props;

    let served_areas = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.served_areas;
    served_areas = this.sortByName(served_areas);
    let specializations =
      agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.specializations;
    specializations = this.sortByName(specializations);

    const showDiv = true;
    const servedAreaInitialState =
      served_areas &&
      served_areas.map((m, i) => {
        if (i < 20) {
          m.showDiv = showDiv;
        }
        return m;
      });

    const specializationsInitialState =
      specializations &&
      specializations.map((m, i) => {
        if (i < 20) {
          m.showDiv = showDiv;
        }
        return m;
      });

    this.setState({
      servedAreaModified: servedAreaInitialState,
      specializationsModified: specializationsInitialState,
    });

    if (window.location.hash && window.location.hash == "#/login") {
      // Fragment exists
      this.showReviewModal();
    } else if (window.location.hash && window.location.hash == "#make_a_recommendation") {
      this.showRecommendationModal();
    } else {
      // Fragment doesn't exist
    }
  }
  trackOmnitureClick(e) {
    trackOmnitureClicks(e.currentTarget.getAttribute("data-linkname"));
  }
  showRecommendationModal = () => {
    trackOmnitureClicks(OMNITURE_LINK_NAME.ADP.WRITE_FIRST_RECOM);
    if (this.props.showRecommendationModal) {
      this.props.showRecommendationModal();
    }
  };
  showReviewModal = () => {
    trackOmnitureClicks(OMNITURE_LINK_NAME.ADP.WRITE_FIRST_REVIEW);
    const { agent_bio } = this.props?.agentdetail;
    this.setState({ isReviewClicks: true });
    const isLogin = this.props?.isUserLoggedIn;
    const loginData = this.props && this.props.loginData;
    const isDotRealtor =
      this.props?.query &&
      this.props?.query.isDotRealtor &&
      JSON.parse(this.props?.query.isDotRealtor)
        ? true
        : false;
    if (isDotRealtor) {
      this.setState({ showDotRealtorRedirectLink: true });
    } else {
      this.setState({ isLogin });
      if (isLogin && loginData) {
        if (this.props && this.props.showReviewModal) {
          this.props.showReviewModal(agent_bio);
        }
      } else {
        window.scrollTo(0, 0);
        this.openLoginModal();
      }
    }
  };

  openLoginModal = async () => {
    setTimeout(() => {
      if (document.querySelector('a[aria-label="Log into your account, opens a dialog"]')) {
        document.querySelector('a[aria-label="Log into your account, opens a dialog"]').click();
      }
    }, 2000);
  };
  submitRequest = (agentdetail, e) => {
    e.stopPropagation();
    const query = this.props && this.props.query;

    const agentProps = agentdetail && agentdetail.agent_bio;
    const advertiser_id = agentProps && agentProps.advertiser_id;
    const address = agentProps && agentProps.address;
    const person_name = agentProps && agentProps.person_name;
    const profileId = agentProps && agentProps.id;
    const web_url = getProfileUrl(agentProps && agentProps.id, SELECT_TYPE.AGENT);
    const phones = agentProps && agentProps.phones;
    const href = agentProps && agentProps.href;
    const types = agentProps && agentProps.types;
    const cid = query && query.cid;
    const lex_id = query && query.lex_id;

    let photo = agentProps && agentProps.photo && agentProps.photo.href;
    photo = photo.split("http:");
    photo = photo[1];
    let requestBody = this.state.requestBody;
    requestBody.advertiser_id = advertiser_id;
    requestBody.referral = cid;
    requestBody.referral_asset = lex_id;
    const city = (address && address.city) || null;
    const stateCode = (address && address.state_code) || null;
    requestBody.city = city;
    requestBody.address = city && stateCode ? `${city}, ${stateCode}` : null;
    requestBody.adv_name = person_name || null;
    requestBody.url = web_url || null;
    requestBody.web_url = href || null;
    requestBody.photo = photo || null;
    requestBody.zip = (address && address.postal_code) || null;
    requestBody.state = stateCode;
    requestBody.type = types || null;
    requestBody.profileId = profileId;
    requestBody.is_monetized = false;
    if (phones && phones.length) {
      requestBody.number = phones[0].number ? encrypt(phones[0].number) : null;
      requestBody.number_type = phones[0].type;
    }
    if (this.props.askAQuestion) {
      this.props.askAQuestion(this.state.requestBody);
    }
  };

  render() {
    const { agentdetail, lang } = this.props;
    const { settings } = agentdetail?.agent_bio;
    const personName = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.person_name;
    let firstYear = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.first_year;
    firstYear = firstYear > 1000 ? new Date().getFullYear() - firstYear : firstYear;

    const agentData = agentdetail?.agent_bio || {};
    const yearExpObj = agentData && getAgentExp(agentData);
    const yearString =
      yearExpObj.years > 0
        ? agentData.first_year > 1000
          ? `${yearExpObj.years} ${lang && lang.ldp_content && lang.ldp_content.years}`
          : `${agentData.first_year} ${lang && lang.ldp_content && lang.ldp_content.years}`
        : "";

    const monthString =
      yearExpObj.months > 0
        ? `${yearExpObj.months} ${
            yearExpObj.months == 1
              ? lang && lang.ldp_content && lang.ldp_content.month
              : lang && lang.ldp_content && lang.ldp_content.months
          }`
        : "";

    const yearofExpString = `${yearString} ${monthString}`;

    let served_areas = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.served_areas;
    served_areas = this.sortByName(served_areas);
    let specializations =
      agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.specializations;
    specializations = this.sortByName(specializations);

    const isLongLength = specializations && checkSpecializationTextLongLength(specializations);

    let description = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.description;

    description = description && description.replace(/\n/g, "<br>");
    const designations = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.designations;

    const for_sale_price = agentdetail && agentdetail.for_sale_price;
    const recently_sold_price = agentdetail && agentdetail.recently_sold_price;
    const canShowPriceRange = settings && settings.display_price_range;

    const priceRange = agentActivityPriceRanges(for_sale_price, recently_sold_price);
    let minPrice = priceRange && priceRange.min && numberToHuman(priceRange.min);
    let maxPrice = priceRange && priceRange.max && numberToHuman(priceRange.max);
    const showMoreAreaLength =
      this.state.servedAreaModified && this.state.servedAreaModified.length;
    const specializationsModifiedLength =
      this.state.specializationsModified && this.state.specializationsModified.length;

    const userLanguages = agentdetail.agent_bio.user_languages || [];
    const agentLanguages = agentdetail.agent_bio.languages || [];

    const nar_only = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.nar_only;
    let languages =
      agentdetail && agentdetail.agent_bio && (userLanguages || agentLanguages)
        ? Array.from(new Set(userLanguages.concat(agentLanguages))).sort(function(first, second) {
            return first.trim().toLowerCase() > second.trim().toLowerCase() ? 1 : -1;
          })
        : [];
    languages = languages.length
      ? chunkify(languages, Math.ceil(languages.length / 4), 4, true)
      : [];

    return (
      <>
        <style jsx>{style}</style>
        <div
          className="preview-main-content"
          id="profile-section"
          data-testid="component-profileSection">
          {/* <link content={profileUrl} /> */} <ProfilePicSection {...this.props} />
          {this.props.isProfileIncomplete && (
            <div className="profile-incomplete-head">
              <ProfileInComplete personName={personName} />
            </div>
          )}
          {!this.props.isProfileIncomplete && (
            <>
              <div className="about-profile">
                <Type styleType="display500">
                  <span className="preview-about-main-About">
                    {lang && lang.ldp_content && lang.ldp_content.about}
                  </span>{" "}
                  {personName && (
                    <span className="icon-realtor-wrapper">
                      <span> {personName}</span>
                      {nar_only ? (
                        <span className="realtor_icon">
                          {" "}
                          <IconRealtorBlockText
                            color="#0060A0"
                            size={5}
                            className="my-alert"
                            role="img"
                            focusable="false"
                            aria-label="profile-section"></IconRealtorBlockText>
                        </span>
                      ) : null}
                    </span>
                  )}
                </Type>
              </div>
              <div>
                <Type as="div" styleType="body300">
                  <div
                    className={
                      description ? "profile-description preview-about-sub" : "preview-about-sub"
                    }>
                    <img
                      className="fallBackImg"
                      alt=""
                      src="data:image/svg+xml;base64,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"
                    />
                    <span
                      id="agent-description"
                      className={"more " + (description ? "showDescription" : "")}>
                      {description ? (
                        <>
                          <ShowMoreText
                            lines={11}
                            more={<MoreLink showMoreText="See more" omnitureTracking="adp" />}
                            less={<LessLink showLessText="See less" />}
                            expanded={false}>
                            {
                              <>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: unescape(description),
                                  }}></p>
                              </>
                            }
                          </ShowMoreText>
                        </>
                      ) : (
                        <>
                          <div>
                            <span className="empty-about">
                              {personName}{" "}
                              {lang &&
                                lang.ldp_content &&
                                lang.ldp_content.has_not_provided_bio_yet}
                            </span>
                          </div>
                          <hr className="section-divider" />
                        </>
                      )}
                    </span>
                  </div>
                </Type>
              </div>
              <div className="preview-more-details">
                <div>
                  {designations && designations.length > 0 ? (
                    <>
                      <Type as="div" styleType="body300">
                        <div className="profile-more-info">Credentials</div>
                      </Type>
                      <MobileOnly>
                        <MobileCertification
                          designations={designations}
                          ulPosition={""}
                          marginTop={"0%"}
                          marginBottom={designations && designations.length > 8 ? "26%" : "0%"}
                          certificationDetails={certificationDetails}></MobileCertification>
                      </MobileOnly>
                      <DesktopOnly>
                        <Certification
                          designations={designations}
                          certificationDetails={certificationDetails}></Certification>
                      </DesktopOnly>
                      <TabletOnly>
                        <Certification
                          designations={designations}
                          certificationDetails={certificationDetails}></Certification>
                      </TabletOnly>
                      <hr className="section-divider" />
                    </>
                  ) : null}
                </div>
                <div className="preview-more-details-profile">
                  {agentData && agentData.first_year ? (
                    <>
                      <div className="preview-profile-info preview-profile-info-right">
                        <Type as="div" styleType="body300">
                          <div className="profile-more-info">
                            {lang && lang.ldp_content && lang.ldp_content.experience}
                          </div>
                        </Type>

                        <Type styleType="body300"> {yearofExpString}</Type>
                      </div>
                      <hr className="section-divider" />
                    </>
                  ) : null}
                  {canShowPriceRange ? (
                    <>
                      <div className="preview-profile-info preview-profile-info-right">
                        <div className={firstYear ? "preview-profile-info-left" : null}>
                          <Type as="div" styleType="body300">
                            <div className="profile-more-info">
                              {lang && lang.ldp_content && lang.ldp_content.price_range}
                            </div>
                          </Type>
                          <Type styleType="body300">
                            {minPrice && maxPrice ? `$${minPrice} - $${maxPrice}` : "None Reported"}
                          </Type>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
                {canShowPriceRange &&
                ((this.state.servedAreaModified && this.state.servedAreaModified.length > 0) ||
                  (this.state.servedAreaModified && this.state.servedAreaModified.length > 0) ||
                  (languages && languages.length > 0)) ? (
                  <hr className="section-divider" />
                ) : (
                  <div className="bottom-margin"></div>
                )}
                {this.state.servedAreaModified && this.state.servedAreaModified.length > 0 ? (
                  <>
                    <MoreDetailsListComponent
                      title={lang && lang.ldp_content && lang.ldp_content.areas_served}
                      id="area_served_set"
                      data={this.state.servedAreaModified}></MoreDetailsListComponent>
                    {showMoreAreaLength > 20 ? (
                      <div
                        id="served"
                        className="showless showless_tab"
                        onClick={
                          this.state.showMoreArea
                            ? () => this.handleLessMoreClick(served_areas, "served_areas")
                            : () => this.handleShowMoreClick(served_areas, "served_areas")
                        }>
                        <p>
                          {this.state.showMoreArea && this.state.showMoretype === "served_areas"
                            ? "Show less areas served"
                            : "Show more areas served"}
                        </p>
                      </div>
                    ) : null}
                    {(this.state.specializationsModified &&
                      this.state.specializationsModified.length > 0) ||
                    (languages && languages.length > 0) ? (
                      <hr className="section-divider" />
                    ) : !description ? (
                      <div className="accordian-divider"></div>
                    ) : null}
                  </>
                ) : null}
                {this.state.specializationsModified &&
                this.state.specializationsModified.length > 0 ? (
                  <>
                    <MoreDetailsListComponent
                      title={lang && lang.ldp_content && lang.ldp_content.specializations}
                      id="specialization_set"
                      isLongLength={isLongLength}
                      data={this.state.specializationsModified}></MoreDetailsListComponent>
                    {specializationsModifiedLength > 20 ? (
                      <div
                        id="served"
                        className="showless showless_tab"
                        onClick={
                          this.state.showMoreArea
                            ? () => this.handleLessMoreClick(specializations, "specializations")
                            : () => this.handleShowMoreClick(specializations, "specializations")
                        }>
                        <p>
                          {this.state.showMoreArea && this.state.showMoretype === "specializations"
                            ? "Show less specializations"
                            : "Show more specializations"}
                        </p>
                      </div>
                    ) : null}
                    {languages && languages.length > 0 ? (
                      <hr className="section-divider" />
                    ) : !description ? (
                      <div className="accordian-divider"></div>
                    ) : null}
                  </>
                ) : null}
                {languages && languages.length ? (
                  <>
                    <MoreDetailsListComponent
                      title="Spoken Languages"
                      id="specialization_set"
                      isLongLength={false}
                      isLanguage={true}
                      data={languages}></MoreDetailsListComponent>
                    {languages.length > 20 ? (
                      <div
                        id="language"
                        className="showless showless_tab"
                        onClick={
                          this.state.showMoreArea
                            ? () => this.handleLessMoreClick(languages, "languages")
                            : () => this.handleShowMoreClick(languages, "languages")
                        }>
                        <p>
                          {this.state.showMoreArea && this.state.showMoretype === "languages"
                            ? "Show less languages"
                            : "Show more languages"}
                        </p>
                      </div>
                    ) : null}
                  </>
                ) : null}
                {!description && languages && languages.length > 0 ? (
                  <div className="accordian-divider"></div>
                ) : null}
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

ProfileSection.defaultProps = {};

ProfileSection.propTypes = {
  agentdetail: PropTypes.object,
  reviewData: PropTypes.array,
  recommendationData: PropTypes.array,
  lang: PropTypes.object,
  showRecommendationModal: PropTypes.func,
  showReviewModal: PropTypes.func,
  clickDetectorAndScroll: PropTypes.func,
  query: PropTypes.object,
  agentData: PropTypes.object,
  web_url: PropTypes.string,
  id: PropTypes.string,
  askAQuestion: PropTypes.func,
  loginData: PropTypes.object,
  isUserLoggedIn: PropTypes.bool,
  ask_a_question_modal: PropTypes.func,
  isMonetizationProfile: PropTypes.bool,
  isProfileIncomplete: PropTypes.bool,
};
